module.exports = __webpack_public_path__ + "static/media/产品介绍2.f12fea7a.png";